import { inject, Service } from '@angular/core';
import type { Observable } from 'rxjs';
import { map, tap } from 'rxjs';
import { AuthStore } from '../../../../../auth/common/stores/auth.store';
import { ApiService } from '../../../../../common/services/api.service';
import type { EngineConfig } from '../interfaces/engine-config';

@Service()
export class EngineConfigService extends ApiService {
  private readonly authStore = inject(AuthStore);

  public getGlobalEngineConfig(): Observable<EngineConfig> {
    return this.get<EngineConfig>('/engine-config/global');
  }

  public updateGlobalEngineConfig(
    config: Omit<EngineConfig, 'group'>,
  ): Observable<void> {
    return this.put<EngineConfig>('/engine-config/global', config).pipe(
      tap((engineConfig) => this.authStore.setEngineConfig(engineConfig)),
      map(() => undefined),
    );
  }
}
